"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBatchOptions = exports.CreateTransferBatch = exports.BatchStatus = void 0;
const mobx_1 = require("mobx");
var BatchStatus;
(function (BatchStatus) {
    BatchStatus["OPEN"] = "open";
    BatchStatus["CLOSED"] = "closed";
})(BatchStatus || (exports.BatchStatus = BatchStatus = {}));
class CreateTransferBatch {
    constructor(batch) {
        this.setQuantity = (quantity) => {
            this.quantity = quantity;
        };
        this.setFromLocationInventory = (fromLocationInventory) => {
            this.fromLocationInventory = fromLocationInventory;
        };
        this.setToLocationInventory = (toLocationInventory) => {
            this.toLocationInventory = toLocationInventory;
        };
        this.batchId = batch.batchId;
        this.batchNumber = batch.batchNumber;
        this.quantityRemaining = batch.quantityRemaining;
        this.quantity = batch.quantity;
    }
}
exports.CreateTransferBatch = CreateTransferBatch;
__decorate([
    mobx_1.observable
], CreateTransferBatch.prototype, "batchId", void 0);
__decorate([
    mobx_1.observable
], CreateTransferBatch.prototype, "batchNumber", void 0);
__decorate([
    mobx_1.observable
], CreateTransferBatch.prototype, "quantityRemaining", void 0);
__decorate([
    mobx_1.observable
], CreateTransferBatch.prototype, "quantity", void 0);
__decorate([
    mobx_1.observable
    // used only in-browser to check current values
], CreateTransferBatch.prototype, "fromLocationInventory", void 0);
__decorate([
    mobx_1.observable
    // used only in-browser to check current values
], CreateTransferBatch.prototype, "toLocationInventory", void 0);
__decorate([
    mobx_1.action
], CreateTransferBatch.prototype, "setQuantity", void 0);
__decorate([
    mobx_1.action
], CreateTransferBatch.prototype, "setFromLocationInventory", void 0);
__decorate([
    mobx_1.action
], CreateTransferBatch.prototype, "setToLocationInventory", void 0);
class CreateBatchOptions {
    constructor(batches) {
        this.selectedBatch = null;
        this.showHiddenBatch = false;
        this.setBatches = (batches) => {
            this.batches = batches;
        };
        this.setBatchOption = (option) => {
            this.selectedBatch = option;
        };
        this.toggleHiddenBatch = () => {
            this.showHiddenBatch = !this.showHiddenBatch;
            // Reset the selectedBatchOption when 0 or negative batch has been selected but not displaying them
            if (this.isSelectedBatchNull) {
                this.setBatchOption(null);
            }
        };
        this.batches = batches;
    }
    get options() {
        let newBatches = this.batches;
        // Hide 0 or negative batches
        if (!this.showHiddenBatch) {
            newBatches = newBatches.filter((batch) => batch.quantityRemaining > 0);
        }
        return newBatches.map((batch) => ({
            label: `${batch.batchNumber}`,
            unit: `${batch.quantityRemaining} ${Math.abs(batch.quantityRemaining) > 1 ? 'units' : 'unit'}`,
            value: batch.id,
            data: batch,
            selected: this.selectedBatch ? this.selectedBatch.value === batch.id : false,
        }));
    }
    get isSelectedBatchNull() {
        const selectedBatch = this.selectedBatch;
        if (!selectedBatch) {
            return true;
        }
        const filtered = this.options.filter((option) => option.value === selectedBatch.value);
        if (filtered.length < 1) {
            return true;
        }
        return false;
    }
}
exports.CreateBatchOptions = CreateBatchOptions;
__decorate([
    mobx_1.observable
], CreateBatchOptions.prototype, "batches", void 0);
__decorate([
    mobx_1.observable
], CreateBatchOptions.prototype, "selectedBatch", void 0);
__decorate([
    mobx_1.observable
], CreateBatchOptions.prototype, "showHiddenBatch", void 0);
__decorate([
    mobx_1.action
], CreateBatchOptions.prototype, "setBatches", void 0);
__decorate([
    mobx_1.action
], CreateBatchOptions.prototype, "setBatchOption", void 0);
__decorate([
    mobx_1.action
], CreateBatchOptions.prototype, "toggleHiddenBatch", void 0);
__decorate([
    mobx_1.computed
], CreateBatchOptions.prototype, "options", null);
__decorate([
    mobx_1.computed
], CreateBatchOptions.prototype, "isSelectedBatchNull", null);
//# sourceMappingURL=batch.js.map